import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import NotFound from 'pages/NotFound';
import { Loaders } from 'shared';
import { Boundary } from 'shared/errors';
import { PrivateRoute, PublicRoute } from 'shared/routes';
import { Forbidden } from 'pages/Forbidden';
import { useUserInit } from 'hooks/useUserInit';
import { rootPaths } from 'routes/paths';

import { AuthRoutes } from 'features/auth/routes';
import { appRoutes } from 'features/app/routes/paths';
import { AppRouter } from 'features/app/routes';
import { PrivacyPolicyPage } from 'pages/PrivacyPolicyPage';
import { TermsAndConditionsPage } from 'pages/TermsAndConditionsPage';

const Routes = () => {
  const userInitialized = useUserInit();

  return (
    <Boundary>
      <Suspense fallback={<Loaders.Loader />}>
        {userInitialized ? (
          <Switch>
            <Route component={NotFound} path={rootPaths.static.notFound} exact />
            <Route component={Forbidden} path={rootPaths.static.forbidden} exact />
            <Route exact path={rootPaths.static.privacyPolicy} component={PrivacyPolicyPage} />
            <Route exact path={rootPaths.static.termsAndConditions} component={TermsAndConditionsPage} />

            <PrivateRoute path={appRoutes.static.root} component={AppRouter} />

            <PublicRoute path={rootPaths.static.root} component={AuthRoutes} />

            <Route>
              <Redirect to={rootPaths.static.notFound} />
            </Route>
          </Switch>
        ) : (
          <Loaders.Loader />
        )}
      </Suspense>
    </Boundary>
  );
};

export default Routes;
